import {
  LOAD_BUREAU_REPORT_DETAIL,
  SAVE_BUREAU_REPORT_DETAIL_OPTIONS,
  CLEAR_BUREAU_REPORT_DETAIL
} from 'src/store/actions/bureauReportActions';

const initialState = {
  items: [],
  count: 0,
  reportInfo: null,
  currentPage: 0,
  searchParams: {}
};

const bureauReportDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_BUREAU_REPORT_DETAIL: {
      return {
        ...initialState
      };
    }
    case SAVE_BUREAU_REPORT_DETAIL_OPTIONS: {
      return {
        ...state,
        searchParams: action.searchParams || {}
      };
    }
    case LOAD_BUREAU_REPORT_DETAIL.success: {
      return {
        ...state,
        items: action.items,
        count: action.count,
        reportInfo: action.reportInfo,
        currentPage: action.page || 0,
        searchParams: action.searchParams ? action.searchParams : state.searchParams
      };
    }
    default: {
      return state;
    }
  }
};

export default bureauReportDetailReducer;

